import { render, staticRenderFns } from "./CarrierDpd.vue?vue&type=template&id=06c1a4ab&scoped=true&"
import script from "./CarrierDpd.vue?vue&type=script&lang=js&"
export * from "./CarrierDpd.vue?vue&type=script&lang=js&"
import style0 from "./CarrierDpd.vue?vue&type=style&index=0&id=06c1a4ab&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c1a4ab",
  null
  
)

export default component.exports